// extracted by mini-css-extract-plugin
export var animationContainer = "_ev-0";
export var asteriskIcon = "_ev-8";
export var conversationLeftSection = "_ev-4";
export var conversationListItem = "_ev-3";
export var conversationMiddleSection = "_ev-5";
export var conversationRightSection = "_ev-6";
export var detailsContent = "_ev-1";
export var listContainer = "_ev-7";
export var modalContent = "_ev-2";